import { render, staticRenderFns } from "./control-table.vue?vue&type=template&id=383fd75d&scoped=true&"
import script from "./control-table.vue?vue&type=script&lang=ts&"
export * from "./control-table.vue?vue&type=script&lang=ts&"
import style0 from "./control-table.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./control-table.vue?vue&type=style&index=1&id=383fd75d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383fd75d",
  null
  
)

export default component.exports